import {
  Box,
  Chip,
  Grid,
  MenuItem,
  Paper,
  Select,
  Typography,
  IconButton,
} from '@mui/material';
import MobileCraneIcon from '@/components/icons/MobileCraneIcon';
import ArrowDownIcon from '@/components/icons/ArrowDownIcon';
import { useEffect, useState } from 'react';
import { Vehicle } from '@/types/api';
import ArrowUpIcon from '@/components/icons/ArrowUpIcon';
//import MapWithAutocomplete from '@/components/MapWithAutocomplete';
import MapStadiaWithAutocomplete from '@/components/MapStadiaWithAutocomplete';
import { useAuthUser } from '@/hooks/auth/useAuth';
import { useGetVehiclesByCompany } from '@/hooks/customer/useVehicles';
import { useGetConfigurationsByCompany } from '@/hooks/customer/useConfigurations';
import MapWithoutGeojson from '@/components/MapWithoutGeojson';
import ManIcon from '@/components/icons/ManIcon';
import DocIcon from '@/components/icons/DocIcon';
import RouteIcon from '@/components/icons/RouteIcon';
import SaveRouteMapIcon from '@/components/icons/SaveRouteMapIcon';
import {
  useSavedRoutes,
  useDeleteSavedRoute,
} from '@/hooks/admin/useSavedRoutes';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import { useNZTA } from '@/hooks/admin/useNzta';
import { useColorMode } from '@/styles/theme';

export default function Configuration() {
  const navigate = useNavigate();
  const { mode } = useColorMode();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data: authUser } = useAuthUser();
  const { configurationId } = useParams();
  const company = authUser?.currentCompany || '0';
  const { data: configurations } = useGetConfigurationsByCompany(
    String(company),
  );
  const { data: vehicles = [] } = useGetVehiclesByCompany(String(company));
  const { data: nztaData = [] } = useNZTA();
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
  const initialOpenedVehicleId = searchParams.get('openedVehicleId');
  const [openedVehicleId, setOpenedVehicleId] = useState<string | null>(
    initialOpenedVehicleId,
  );
  // const [selectedConfiguration, setSelectedConfiguration] = useState<any>(null);
  const [displayVehicles, setDisplayVehicles] = useState<boolean>(true);
  const [displaySavedRoutes, setDisplaySavedRoutes] = useState<boolean>(false);
  const [displayLeftBar, setDisplayLeftBar] = useState<boolean>(true);
  const { data: savedRoutes } = useSavedRoutes();
  const [displayRoutes, setDisplayRoutes] = useState<any>(null);
  const [selectedSavedRoute, setSelectedSavedRoute] = useState<any>(null);
  const deleteSavedRoute = useDeleteSavedRoute();

  const selectedConfiguration =
    configurations?.find((c) => c._id === configurationId) || null;

  useEffect(() => {
    if (selectedVehicle && configurations && !configurationId) {
      const configurationsForVehicle = configurations.filter(
        (c) => c.vehicle === selectedVehicle._id,
      );
      if (configurationsForVehicle.length > 0) {
        navigate(
          `/configurations/view/${configurationsForVehicle[0]._id}?openedVehicleId=${openedVehicleId || ''}`,
          {
            state: {
              selectedVehicle,
              displayLeftBar,
              displayVehicles,
              displaySavedRoutes,
              selectedSavedRoute,
            },
          },
        );
      }
    }
  }, [
    selectedVehicle,
    configurations,
    configurationId,
    company,
    navigate,
    openedVehicleId,
    displayLeftBar,
    displayVehicles,
    displaySavedRoutes,
    selectedSavedRoute,
  ]);

  useEffect(() => {
    setDisplayRoutes(
      savedRoutes?.filter(
        (route) => route.configuration === selectedConfiguration?._id,
      ),
    );
  }, [savedRoutes, selectedConfiguration]);

  // const route = selectedConfiguration?.permits.map(
  //   (permit: any) => permit.route,
  // ) || [];

  let route: any[] = [];

  const validPermits =
    selectedConfiguration?.permits.filter((permit: any) => {
      if (!permit.expiryDate) return true;
      const expiryDate = new Date(permit.expiryDate);
      const currentDate = new Date();
      return expiryDate >= currentDate;
    }) || [];

  route = validPermits.map((permit: any) => permit.route) || [];

  const councilIds: any[] =
    validPermits
      .filter((permit: any) => permit?.councils)
      .map((permit: any) => permit.councils)
      .flat() || [];

  const selectedConfigurationRcas = validPermits.map((permit) => permit.rca);

  const councils: any[] =
    nztaData
      ?.filter((nzta) => selectedConfigurationRcas?.find((s) => s === nzta._id))
      .map((nzta) => nzta.councils)
      .flat()
      .filter((council) => councilIds.find((c) => c._id === council._id))
      .map((c) => c.geojson) || [];

  route = [...route, ...councils];

  const onClickDocs = () => {
    const params: any = {};
    if (selectedVehicle?.rego) {
      params.vehicleRego = selectedVehicle.rego;
    }
    if (selectedConfiguration?.name) {
      params.configurationName = selectedConfiguration.name;
    }

    navigate({
      pathname: '/permits',
      search: `?${new URLSearchParams(params)}`,
    });
  };

  const onClickRoute = () => {
    setDisplayVehicles(false);
    navigate(`/configurations/${configurationId}/saved-routes`);
  };

  // const onClickVehicle = () => {
  //   setDisplayVehicles(true);
  //   setDisplaySavedRoutes(false);
  // };

  const onClickVehicle = () => {
    setDisplayVehicles(true);
    setDisplaySavedRoutes(false);
    setSelectedSavedRoute(null);
    navigate(
      `/configurations/view/${configurationId}?openedVehicleId=${openedVehicleId || ''}`,
      {
        state: {
          selectedVehicle,
          displayLeftBar,
          displayVehicles,
          displaySavedRoutes,
          selectedSavedRoute: null,
        },
      },
    );
  };

  const onClickSwitchLeftBar = () => {
    setDisplayLeftBar(!displayLeftBar);
  };

  const handleDelete = (id: string) => {
    deleteSavedRoute.mutate(id);
  };

  // const councilIds: any[] =
  //   selectedConfiguration?.permits
  //     .filter((permit: any) => permit?.councils)
  //     .map((permit: any) => permit.councils)
  //     .flat() || [];

  return (
    <Box>
      <Grid container spacing={1}>
        {displayLeftBar && (
          <Grid
            item
            xs={displayLeftBar ? 4 : 0}
            sx={{
              height: '100vh',
              overflowY: 'auto',
            }}
          >
            {displayVehicles && (
              <Box>
                <Box
                  px={3}
                  display="flex"
                  justifyContent="start"
                  alignItems="center"
                  sx={{ marginTop: '-10px' }}
                >
                  <Typography sx={{ fontSize: '14px', textAlign: 'center' }}>
                    VEHICLE CONFIGURATIONS
                  </Typography>
                </Box>
                {vehicles.map((vehicle) => {
                  // todo: extract this into another component
                  const configurationsForVehicle = configurations?.filter(
                    (c) => c.vehicle === vehicle._id,
                  );

                  const isVehicleSelected =
                    selectedVehicle?._id === vehicle._id;
                  const isVehicleOpened = openedVehicleId === vehicle._id;

                  return (
                    <Paper
                      key={vehicle._id}
                      sx={{
                        width: '99%',
                        background:
                          mode === 'dark' ? '#334657' : '#FFF4EB !important',
                        borderRadius: '6px',
                        border: `0.5px solid ${isVehicleSelected ? '#F6AE2D' : 'transparent'}`,
                        paddingY: '15px',
                        mt: 1,
                        ml: 1,
                        cursor: 'pointer',
                      }}
                    >
                      <Box
                        component="div"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        px={2}
                        onClick={() => {
                          setSelectedVehicle(vehicle);
                          setOpenedVehicleId(vehicle._id);
                          searchParams.set('openedVehicleId', vehicle._id);
                          setSearchParams(searchParams);
                          const configurationsForVehicle =
                            configurations?.filter(
                              (c) => c.vehicle === vehicle._id,
                            );
                          if (
                            configurationsForVehicle &&
                            configurationsForVehicle.length > 0
                          ) {
                            const defaultConfig = configurationsForVehicle[0];
                            navigate(
                              `/configurations/view/${defaultConfig._id}?openedVehicleId=${vehicle._id}`,
                              {
                                state: {
                                  selectedVehicle: vehicle,
                                  displayLeftBar,
                                  displayVehicles,
                                  displaySavedRoutes,
                                  selectedSavedRoute,
                                },
                              },
                            );
                          }
                        }}
                      >
                        <Box display="flex" alignItems="center">
                          <MobileCraneIcon />
                        </Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          flexGrow={1}
                          ml={2}
                        >
                          <Chip
                            sx={{
                              background: '#fff',
                              borderRadius: '6px',
                              width: '100px',
                              ...(mode === 'light' && {
                                border: '2px solid #202D38',
                              }),
                            }}
                            label={
                              <Typography
                                variant="subtitle1"
                                sx={{
                                  color: '#202D38',
                                }}
                              >
                                {vehicle.rego || 'N/A'}
                              </Typography>
                            }
                          />
                          <Typography sx={{ ml: 2, fontSize: '12px' }}>
                            FLEET: #{vehicle.fleetNumber || 'N/A'}{' '}
                          </Typography>
                        </Box>

                        {/* Right Icon */}
                        <Box
                          display="flex"
                          alignItems="center"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOpenedVehicleId(
                              isVehicleOpened ? null : vehicle._id,
                            );
                          }}
                        >
                          {isVehicleOpened ? (
                            <ArrowUpIcon mode={mode} />
                          ) : (
                            <ArrowDownIcon />
                          )}
                        </Box>
                      </Box>

                      {/* Configurations Dropdown */}
                      {isVehicleOpened &&
                        configurationsForVehicle &&
                        configurationsForVehicle.length > 0 && (
                          <>
                            <Box px={2} mt={2}>
                              <Select
                                variant="filled"
                                fullWidth
                                value={selectedConfiguration?._id || ''}
                                onChange={(e) => {
                                  setSelectedSavedRoute(null);
                                  navigate(
                                    `/configurations/view/${e.target.value}?openedVehicleId=${openedVehicleId || ''}`,
                                  );
                                }}
                                sx={{
                                  '& .MuiSvgIcon-root': {
                                    color: 'primary.main',
                                  },
                                }}
                                MenuProps={{
                                  slotProps: {
                                    paper: {
                                      sx: {
                                        ...(mode === 'light' && {
                                          background: '#FFE6B0 !important',
                                        }),
                                      },
                                    },
                                  },
                                }}
                              >
                                {configurationsForVehicle.map((config) => (
                                  <MenuItem
                                    key={config._id}
                                    value={config._id}
                                    sx={{
                                      ...(mode === 'light' && {
                                        background: '#FFE6B0',
                                      }),
                                    }}
                                  >
                                    {config.name ||
                                      `Configuration ${config._id}`}
                                  </MenuItem>
                                ))}
                              </Select>
                            </Box>
                            {selectedConfiguration &&
                              openedVehicleId ==
                                selectedConfiguration.vehicle && (
                                <Box
                                  px={2}
                                  mt={2}
                                  pt={1}
                                  pb={1}
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-evenly"
                                >
                                  <IconButton onClick={() => {}}>
                                    <ManIcon />
                                  </IconButton>
                                  <IconButton onClick={onClickDocs}>
                                    <DocIcon />
                                  </IconButton>
                                  <IconButton onClick={onClickRoute}>
                                    <RouteIcon />
                                  </IconButton>
                                  <IconButton onClick={() => {}}>
                                    <SaveRouteMapIcon />
                                  </IconButton>
                                </Box>
                              )}
                          </>
                        )}
                    </Paper>
                  );
                })}
              </Box>
            )}
          </Grid>
        )}

        <Grid
          item
          xs={displayLeftBar ? 8 : 12}
          sx={{ paddingTop: 0, marginTop: '-20px' }}
        >
          {route ||
          selectedConfigurationRcas?.includes('67f300c6ad9e642314798147') ||
          selectedConfigurationRcas?.includes('6813022984065d0306faa7ac') ? (
            <MapStadiaWithAutocomplete
              routeData={{
                geojsonData: route,
                ...selectedSavedRoute,
              }}
              show50MaxData={
                selectedConfigurationRcas?.includes(
                  '67f300c6ad9e642314798147',
                ) || false
              }
              showHpmvData={
                selectedConfigurationRcas?.includes(
                  '6813022984065d0306faa7ac',
                ) || false
              }
              company={String(company)}
              configuration={selectedConfiguration?._id || ''}
              switchLeftBar={onClickSwitchLeftBar}
              displayLeftBar={displayLeftBar}
            />
          ) : (
            <MapWithoutGeojson
              switchLeftBar={onClickSwitchLeftBar}
              displayLeftBar={displayLeftBar}
            />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
